<template>
  <div
    v-if="roles.documentsWithRoles.length"
    class="p-sm py-base gap-base sm:grid-cols-rolesGrid3 flex flex-col sm:grid"
  >
    <HeaderContainer
      v-for="document in roles.documentsWithRoles"
      :key="document.fingerprint"
      class="rounded-md"
    >
      <template v-slot:header>
        <label
          :id="`p-${partyIndex}-${document.fingerprint}`"
          class="flex leading-normal py-sm -mx-sm"
        >
          {{ $t('ui.envelopes.create.steps.parties.on') }}&nbsp;
          <strong
            :title="document.title"
            class="truncate"
          >
            {{ document.title }}
          </strong>
          &nbsp;
          <span class="whitespace-nowrap">
            {{ $t('ui.envelopes.create.steps.parties.theyAre') }}:
          </span>
        </label>
      </template>

      <div
        class="px-sm m-0"
        role="listbox"
        :aria-labelledby="`p-${partyIndex}-${document.fingerprint}`"
      >
        <template v-for="role in document.parties.filter((party) => party.role)">
          <button
            :key="role.id"
            class="flex items-center justify-between w-full px-twenty py-sm my-sm border-none bg-transparent hover:bg-offWhite font-body font-medium text-base text-current rounded-full cursor-pointer"
            :class="{
              '!bg-primaryGradient !text-whiteOverride hover:!bg-primaryHoverDark':
                roles.hasRole(partyIndex, role.id),
              '!text-disabledGrey !cursor-default !bg-transparent hover:!bg-transparent':
                !roles.availableRole(partyIndex, role.id),
            }"
            type="button"
            role="option"
            :aria-selected="roles.hasRole(partyIndex, role.id)"
            :aria-disabled="!roles.availableRole(partyIndex, role.id)"
            @click="toggleRole(partyIndex, role.id)"
          >
            {{ role.title }}

            <FontIcon
              v-if="roles.hasRole(partyIndex, role.id)"
              name="times"
            />

            <span
              v-if="!roles.availableRole(partyIndex, role.id)"
              class="contents whitespace-nowrap"
            >
              ({{ $t('ui.envelopes.create.steps.parties.assignedTo', { id: roles.assignedTo(role.id) + 1 }) }})
            </span>
          </button>
        </template>
      </div>
    </HeaderContainer>
  </div>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';

import FontIcon from '@/components/Icon.vue';
import { HeaderContainer } from '@/components/library/containers/HeaderContainer';

export default defineComponent({
  components: { FontIcon, HeaderContainer },
  props: {
    roles: {
      /** @type {import('vue').PropType<import('@/composables/roles/roles').TRoles>} */
      type: Object,
      required: true,
    },
    partyIndex: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    /**
     * @param {number} partyIndex
     * @param {number} roleId
     */
    const toggleRole = (partyIndex, roleId) => {
      if (props.roles.availableRole(partyIndex, roleId)) {
        emit('toggle', partyIndex, roleId);
      }
    };

    return {
      toggleRole,
    };
  },
});
</script>
